import { Search, Edit, Person } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType, FormActions, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";
import { FilterForm } from "../../../components/form/filter-form";




const schema = yup.object({
  centro_operacion:yup.mixed().required(),
  municipio:yup.mixed().required(),
  barrio:yup.mixed().required(),
  cod_tipo_entrega:yup.string().required(),
  costo_general_servicio:yup.number().min(0).required(),
  costo_um:yup.number().min(0).required(),
  ind_estado:yup.string().required()
}).required();


const schemaFilter = yup.object({
  centro_operacion:yup.mixed().required(),
  municipio:yup.mixed().notRequired().optional(),
 
}).required();


const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  centro_operacion:null,
  municipio:null
};

const defaultEntity = {
  centro_operacion:null,
  municipio:null,
  barrio:null,
  cod_tipo_entrega:null,
  costo_general_servicio:null,
  costo_um:null,
  ind_estado:'HABILITADO',
}

export const MaestroServiciosUltimaMilla = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);

  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [barrios,setBarrios] = useState([]);
  const [ciudades,setCiudades] = useState([]);
  const [tipoServicio,setTipoServicio] = useState([]);

  const [centrosOp,setCentrosOp] = useState([]);

  



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });

      await loadCentrosOperaciones();
      await loadTiposServicios();
      //await loadItems(false);

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    
    const loadCentrosOperaciones = async()=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion-enabled-seller");
      setCentrosOp(value.map(item=>({label:item.descripcion,value:item.cod})));
    }
    const loadTiposServicios = async()=>{
      const  {data:{value}} = await AxiosInstance.get("auditoria/obtener-tipos-servicios");
      setTipoServicio(value);
    }

    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      return value;
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("auditoria/consultar-costos-servicios",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value?.data]);

     setTotalRows(value?.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      product.centro_operacion = {label:product.centro_operacion_nombre,value:product.centro_operacion_cod};
      product.municipio = {label:product.municipio_label,value:product.municipio_cod};
      product.barrio = {label:product.barrio_nombre,value:product.barrio_cod};
      product.cod_tipo_entrega = product.tipo_entrega_cod;
      product.costo_general_servicio = Number(product.costo_general_servicio);
      product.costo_um = Number(product.costo_um);
      product.ind_estado = product.ind_estado;
      setProductoSeleccionado(product || {});
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);
    
    }



    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...defaultEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      console.log({typeAction,dataForm});
      const urlService = "auditoria/crear-editar-costo-servicios";
      
    
      const payload = {
        cod:dataForm.cod,
        cod_centro_operacion:dataForm.centro_operacion.value,
        cod_municipio:dataForm.municipio.value,
        cod_barrio:dataForm.barrio.value,
        cod_tipo_entrega:dataForm.cod_tipo_entrega,
        costo_general_servicio:dataForm.costo_general_servicio,
        costo_um:dataForm.costo_um,
        ind_estado:dataForm.ind_estado
      };
      console.log({payload});
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async ({data})=>{

          if ( data.status ){
            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Registro agregado",
                  message:"",
                  type:DialogType.exitoso,
                  isVisible:true
              }
          });
          }else{
            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Dato no registrado",
                  message:data.msg,
                  type:DialogType.informativo,
                  isVisible:true
              }
          });
          }

          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          console.log(err.message);
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

 
    


    
    const onSearchMunicipio = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-municipio-filter", {
            search_query: value_search
          });
          setCiudades(value.map( item=>({label:item.name_raw,value:item.cod,barrios:item.barrios}) ));
          return value;
         }catch(e){
          return [];
         }
  
      }
   }
    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }


   
    const searchCentroOperacion = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }

  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"centro_operacion_nombre",
        keyValue:"centro_operacion_nombre",
        label:"Centro de OP",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
      {
      
        key:"municipio_label",
        keyValue:"municipio_label",
        label:"Municipio",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"barrio_nombre",
        keyValue:"barrio_nombre",
        label:"Barrio",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"tipo_entrega_nombre",
        keyValue:"tipo_entrega_nombre",
        label:"Tipo de servicio",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"costo_general_servicio",
        keyValue:"costo_general_servicio",
        label:"Costo general del servicio",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"costo_um",
        keyValue:"costo_um",
        label:"Costo X U.N",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      

       {
      
        key:"ind_estado",
        keyValue:"ind_estado",
        label:"Estado",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
        {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button size="small" onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
        
    ];



    const configModal =  {
      onSendForm:onSaveDataForm,
      typeAction:tipoAction,
      schemaValidator:schema,
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar Servicio":'Modificar Servicio',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key: "centro_operacion",
          keyValue: "centro_operacion",
          label: "Centro de operacion",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            size:"small",
            name: 'centro_operacion',
            fullWidth: true,
            isLoading: false,
            multiple:false,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searchCentroOperacion,
            options: centrosOp || [],
            noOptionsText: "Lista vacia",
          }
        },
        {
          key: "municipio",
          keyValue: "municipio",
          label: "Ciudad",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          callFuncionOnChange:(value,formProps)=>{
            console.log({value});
            if ( value.barrios  ){
              setBarrios(value.barrios);
              return;
            }
            formProps.setValue("barrio",null);
           
          },
          inputProps: {
            size:"small",
            name: 'municipio',
            fullWidth: true,
            isLoading: false,
            multiple:false,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: (e,value)=>onSearchMunicipio(value),
            options: ciudades || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },
        {
          key: "barrio",
          keyValue: "barrio",
          label: "Barrio",
          component: AutoCompleteInputWithLabel,
          responsiveSize:6,
          inputProps: {
            size:"small",
            name: 'barrio',
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
           // onInputChange: searchCentroOperacion,
            options: barrios || [],
            noOptionsText: "Lista vacia",

          }
        },
        {
          key:"cod_tipo_entrega",
          keyValue:"cod_tipo_entrega",
          label:"Tipo de servicio",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:tipoServicio
          }
        },
        {
          key:"costo_general_servicio",
          keyValue:"costo_general_servicio",
          label:"Costo General del servicio",
          component:InputWithLabel,
          inputProps:{
            type:"number",
            size:"small"
          }
        },
        {
          key:"costo_um",
          keyValue:"costo_um",
          label:"Costo por KG",
          component:InputWithLabel,
          inputProps:{
            type:"number",
            size:"small"
          }
        },
        {
          key:"ind_estado",
          keyValue:"ind_estado",
          label:"Estado",
          component:SelectInputWithLabel,
          inputProps:{
            size:"small",
            items:[
              {
                value:"HABILITADO",
                label:"HABILITADO"
              },
              {
                value:"DESHABILITADO",
                label:"DESHABILITADO"
              },
              
            ],
            type:"select",
       
          }
        },
       
      
       
      ],
      arrayInputs:[]
    } ;



    const InputFilters = [
      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"centro_operacion",
        InputComponentProps:{
          label:"Centro de operacion",
          size:"small",
          name: 'centro_operacion',
          fullWidth: true,
          isLoading: false,
          multiple:false,
          PopperComponent:(props)=><div hidden={!props.open} >
          
            {props.children}
          </div>,
          onInputChange: searchCentroOperacion,
          options: centrosOp || [],
          noOptionsText: "Lista vacia",
        }
      },

      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"municipio",
        InputComponentProps:{
          label:"Municipio",
          size:"small",
          name: 'municipio',
          fullWidth: true,
          isLoading: false,
          multiple:false,
          PopperComponent:(props)=><div hidden={!props.open} >
           
             {props.children}
          </div>,
          onInputChange: (e,value)=>onSearchMunicipio(value),
          options: ciudades || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
     /*  {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:SelectInputWithLabel,
        keyValue:"estado_cesta",
        items:["TODAS","BORRADOR","PRECONFIRMADO","CONFIRMADO","ERROR"].map(ele=>({value:ele,label:ele})),
        InputComponentProps:{
          label:"Estado",
          fullWidth: true,
          size:'small',

        }
      }, */
     
      ];

      const  setFilterAply = (filtros)=>{
        console.log({filtros});
        setFilterSearchPagination({
          ...filterSearchPagination,
          centro_operacion:filtros.centro_operacion?.value,
          municipio:filtros.municipio?.value,
       
        });
       
      }


    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
   
    />
    }


   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={7} >

        <FilterForm
            buttomDist={
              {
                sx:3,
                md:3
              }
            }
            nameFilter={"Buscar compras por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={{...filterSearchPagination}}
            onApplyFilter={setFilterAply}
          />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >
          <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nuevo servicio</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}